import styled from "styled-components";
import FlexBox from "../../Components/FlexBox/FlexBox";

export const _PhoneNumberInputOpion = styled(FlexBox)(() => {
  return {
    padding: "0px 16px",
  };
});
